import './create/tool-data';
import Onlynumber from "./create/onlynumber";
import Timer from "./create/timer";
import Placeholder from "./create/placeholder";
import placeholderInfo from "./create/placeholder-info";
import layerInfo from "./create/layer-info";
import Selection from './create/selection';
import animation from './create/animation';

let authPhone = new Onlynumber({
    el:"#auth-phone"
});

let authNumber = new Onlynumber({
    el:"#auth-number"
});

let page = promokit.page({
    caution: '#section-caution',
    cnb: true, //true, false
    topButton: true, //true, false
    footer: {
        theme: 'black' //'black', 'white'
    },
    headerButton: {
        el: '.header-button',
        home: true,
        event: true,
        sns: true,
        theme: 'black' //'black', 'white'
    }
});

window.placeholder = {};
window.timerPreorder = new Timer({
    el:"#timer-preorder",
    minutes:5,
    start:false
});

$.each(placeholderInfo, (key, value)=>{
    placeholder[key] = new Placeholder({
        el:value
    });
});

$.each(layerInfo, function(index, value){
    promokit.layer({
        el:value.el,
        buttons:value.btn,
    });
});

window.selection = new Selection({
    el:"#selection",
    data:{
        tribe:30,
        gender:0,
        job:208,
    },
    complete:false,
    callback(){
        if(this.targetEvent!=="tribe") return;
        console.log(this.targetEvent)
        animation.character(this.curr.tribe);
    }
});

$(document).on('click', '.p-btn__coupon', function(e) {
    e.preventDefault();
    promokit.coupon();
    // promokit.message({
    //     type: 'alert',
    //     message: '쿠폰등록 기간이 종료되었습니다.',
    //     done: function() {
    //         console.log('alert 확인 버튼 누름');
    //     }
    // });
});


// WEBPACK FOOTER //
// ./src/js/create.js